<template>
  <div class="mod-mrp-run">
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="MRP批次号"><el-input v-model="q.mrpRunCode" size="small" clearable /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="q.runStatus" size="small" clearable style="width:100px">
          <el-option label="草稿" value="0" /><el-option label="已运行" value="1" /><el-option label="已确认" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('production:mrpRun:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('production:mrpRun:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" width="50" />
      <el-table-column prop="mrpRunCode" label="批次号" min-width="130">
        <template slot-scope="s">
          <a v-if="isAuth('production:mrpRun:info')" class="code-link" @click="openInfo(s.row)">{{ s.row.mrpRunCode }}</a>
          <span v-else>{{ s.row.mrpRunCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="runDate" label="运算日期" width="110"><template slot-scope="s">{{ (s.row.runDate || '').slice(0, 10) }}</template></el-table-column>
      <el-table-column prop="runStatus" label="状态" width="90" align="center">
        <template slot-scope="s">
          <el-tag v-if="s.row.runStatus === '1'" type="success" size="small">已运行</el-tag>
          <el-tag v-else-if="s.row.runStatus === '2'" type="primary" size="small">已确认</el-tag>
          <el-tag v-else type="info" size="small">草稿</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="360" fixed="right">
        <template slot-scope="s">
          <el-button v-if="isAuth('production:mrpRun:info')" type="text" @click="openInfo(s.row)">详情</el-button>
          <el-button v-if="(isAuth('production:mrpRun:run') || isAuth('production:mrpRun:save')) && (s.row.runStatus === '0' || s.row.runStatus === '1')" type="text" @click="doRun(s.row)">运算</el-button>
          <el-button v-if="isAuth('production:mrpRun:generatePlanned') && s.row.runStatus === '1'" type="text" @click="generatePlanned(s.row)">生成计划单</el-button>
          <el-button v-if="isAuth('production:mrpRun:generatePurchase') && (s.row.runStatus === '1' || s.row.runStatus === '2')" type="text" @click="generatePurchase(s.row)">生成采购单</el-button>
          <el-button v-if="isAuth('production:mrpRun:update') || isAuth('production:mrpRun:save')" type="text" :disabled="s.row.runStatus !== '0'" @click="open(s.row.mrpRunId)">修改</el-button>
          <el-button v-if="isAuth('production:mrpRun:delete')" type="text" :disabled="s.row.runStatus !== '0'" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-size="20" layout="total, prev, pager, next" :total="total"
      @current-change="p => { pageIndex = p }" />

    <mrp-run-add-or-update v-if="editVisible" ref="editDialog" @refreshDataList="load" />
    <mrp-run-info v-if="infoMounted" ref="infoDialog" @generate-planned="generatePlanned" @generate-purchase="generatePurchase" @delete-run="remove" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MrpRunAddOrUpdate from './mrpRun-add-or-update.vue'
import MrpRunInfo from './mrpRun-info.vue'

export default {
  name: 'MrpRun',
  components: { MrpRunAddOrUpdate, MrpRunInfo },
  data() {
    return {
      q: { mrpRunCode: '', runStatus: '' }, list: [], loading: false, pageIndex: 1, permCodes: [],
      editVisible: false, infoMounted: false,
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => {
        const code = (this.q.mrpRunCode || '').trim()
        if (code && String(row.mrpRunCode || '').indexOf(code) < 0) return false
        if (this.q.runStatus && String(row.runStatus) !== this.q.runStatus) return false
        return true
      })
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * 20, this.pageIndex * 20) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plan/mrp/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(id) {
      this.editVisible = true
      this.$nextTick(() => this.$refs.editDialog && this.$refs.editDialog.init(id))
    },
    openInfo(row) {
      this.infoMounted = true
      this.$nextTick(() => this.$refs.infoDialog && this.$refs.infoDialog.init(row))
    },
    doRun(row) {
      this.$confirm('按当前批次参数执行MRP运算？', '提示', { type: 'warning' }).then(() => {
        request.post('/plan/mrp/run', { mrpRunId: row.mrpRunId }).then(() => {
          this.$message.success('运算完成')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    generatePlanned(row) {
      this.$confirm('按净需求生成计划订单？外购/委外若已生成采购单则跳过。', '提示', { type: 'warning' }).then(() => {
        request.post('/plan/mrp/generatePlanned', { mrpRunId: row.mrpRunId }).then(res => {
          this.$message.success('已生成 ' + (res.data || 0) + ' 张计划订单')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    generatePurchase(row) {
      this.$confirm('按外购/委外净需求、按主供应商生成采购订单？', '提示', { type: 'warning' }).then(() => {
        request.post('/plan/mrp/generatePurchase', { mrpRunId: row.mrpRunId }).then(res => {
          const data = res.data || {}
          const skipped = data.skipped || []
          this.$message.success('已生成 ' + (data.created || 0) + ' 张采购订单' + (skipped.length ? '，未维护主供应商已跳过：' + skipped.join('、') : ''))
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    remove(row) {
      this.$confirm('仅草稿可删除，删除后运算结果一并清除。', '提示', { type: 'warning' }).then(() => {
        request.post('/plan/mrp/delete', { mrpRunId: row.mrpRunId }).then(() => {
          this.$message.success('已删除')
          if (this.$refs.infoDialog) this.$refs.infoDialog.close()
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
